<template>
  <div>
    <ul class="addressList">
      <li v-for="(item, index) in list" :key="index">
        <span>{{ item.address }}</span>
        <Icon @click="remove(index)" type="md-close-circle" />
      </li>
    </ul>
    <Button @click="$refs.selectAddMap.openDrawer()">新增地址</Button>
    <selectAddMap
      :hideInput="true"
      @adds="reAdds"
      ref="selectAddMap"
    ></selectAddMap>
  </div>
</template>
<script>
export default {
  props: ["abc"],
  data() {
    return {
      list: [],
    };
  },
  methods: {
    remove(index) {
      this.list.splice(index, 1);
    },
    reAdds(v) {
      var obj = {
        address: v.address,
        x: v.x,
        y: v.y,
        isUse: 0,
      };
      this.list.push(obj);
      //this.$emit('aaa',this.list);
    },
  },
  model: {
    prop: "abc",
    //event: "aaa",
  },
  mounted() {
    this.list=this.abc;
  },

};
</script>
<style>
.addressList li {
  line-height: 1.2;
  padding: 6px 4px;
  position: relative;
}
.addressList li i {
  cursor: pointer;
  display: none;
  position: absolute;
  top: 6px;
  right: -2px;
  font-size: 14px;
}
.addressList li:hover {
  background: #f4faff;
}
.addressList li:hover i {
  display: inline;
}
</style>


// WEBPACK FOOTER //
// src/components/wuliu/addressList.vue